import { Api } from "../config/request";

export const getPayoutList = (rideId) => {
    return Api.getRequest(`payout/${rideId}`);
};

export const addPayout = async (payoutData) => {
    try {
        const response = await Api.postRequest('payout', payoutData);
        return response;
    } catch (error) {
        throw new Error(error.response?.data?.message || error.message || 'Failed to add payout');
    }
};

const PayoutAPI = {
    getPayoutList,
    addPayout,
};

export default PayoutAPI;
